import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import VagasPage from './pages/VagasPage';
import VagaDetalhesPage from './pages/VagaDetalhesPage';
import AboutPage from './pages/AboutPage';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Footer from "./components/Footer"; 
import ServicesPage from './pages/ServicesPage';
import TrainingsPage from './pages/TrainingsPage';

function App(){
  return (
    <BrowserRouter>
      <Navbar
        style={{ position: "relative" }}
      />
      <Box style={{ backgroundColor: "gainsboro", marginTop: "50px" }}>
        <Paper className="container pr-1 pl-1 pb-1" style={{ backgroundColor: "white", minWidth: "90%", minHeight: "82.5vh", paddingTop: "10px" }} elevation={24}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/vagas" element={<VagasPage />} />
            <Route path="/identidade" element={<AboutPage />} />
            <Route path="/servicos" element={<ServicesPage />} />
            <Route path="/treinamentos" element={<TrainingsPage />} />
            <Route path="/vaga/:code" element={<VagaDetalhesPage />} />
          </Routes>
        </Paper>
        <Footer />
      </Box>
    </BrowserRouter>
  );
}

export default App;
